/**
 * Trust Leiste — mobile item rotation and shipping countdown.
 * Cycles through trust items every 5 seconds on mobile.
 * Counts down the next-shipping cutoff once per second.
 */
(function () {
  const container = document.getElementById('trust-leiste');
  if (!container) {
    return;
  }

  initShippingCountdown(container);
  initMobileRotation(container);

  function initShippingCountdown(container) {
    const item = container.querySelector('[data-default-cutoff], [data-express-cutoff]');
    if (!item) {
      return;
    }

    // Absolute cutoff timestamps come from the server so cached HTML stays
    // correct as the page's fragment cache ages. See CTVSP-8870.
    const defaultCutoff = parseCutoff(item.dataset.defaultCutoff);
    const expressCutoff = parseCutoff(item.dataset.expressCutoff);
    if (defaultCutoff === null && expressCutoff === null) {
      return;
    }

    const labelEl = item.querySelector('.trust_leiste__label');
    if (!labelEl) {
      return;
    }

    const defaultPrefix = item.dataset.defaultPrefix || '';
    const expressPrefix = item.dataset.expressPrefix || '';
    const fallbackLabel = labelEl.textContent.trim();

    const prefixNode = document.createTextNode('');
    const timeEl = document.createElement('time');
    timeEl.className = 'usp_next_shipping';
    labelEl.replaceChildren(prefixNode, timeEl);

    let currentPrefix = null;

    function tick() {
      const now = Date.now();
      // Pick the soonest upcoming cutoff. The server may emit tomorrow's express cutoff
      // alongside today's still-open default cutoff, so we can't always pick express first.
      const candidates = [];
      if (expressCutoff !== null && expressCutoff > now) {
        candidates.push({ ts: expressCutoff, prefix: expressPrefix });
      }
      if (defaultCutoff !== null && defaultCutoff > now) {
        candidates.push({ ts: defaultCutoff, prefix: defaultPrefix });
      }
      if (candidates.length === 0) {
        labelEl.replaceChildren(document.createTextNode(fallbackLabel));
        return false;
      }
      candidates.sort((left, right) => left.ts - right.ts);
      const { ts: activeCutoff, prefix } = candidates[0];

      if (prefix !== currentPrefix) {
        prefixNode.data = prefix + ' ';
        currentPrefix = prefix;
      }

      const remaining = Math.max(0, Math.floor((activeCutoff - now) / 1000));
      timeEl.setAttribute('datetime', new Date(activeCutoff).toISOString());
      timeEl.textContent = formatHms(remaining);
      return true;
    }

    if (!tick()) {
      return;
    }
    const intervalId = window.setInterval(function () {
      if (!tick()) {
        window.clearInterval(intervalId);
      }
    }, 1000);
  }

  function parseCutoff(value) {
    if (!value) {
      return null;
    }
    const ts = Date.parse(value);
    return Number.isFinite(ts) ? ts : null;
  }

  function formatHms(totalSeconds) {
    const h = Math.floor(totalSeconds / 3600);
    const m = Math.floor((totalSeconds % 3600) / 60);
    const s = totalSeconds % 60;
    const pad = (n) => (n < 10 ? '0' : '') + n;
    return pad(h) + ':' + pad(m) + ':' + pad(s);
  }

  function initMobileRotation(container) {
    const items = container.querySelectorAll('.js_trust_leiste_item');
    if (items.length <= 1) {
      return;
    }

    function selectNext() {
      let active = container.querySelector('.mobile_active');
      let next = active ? active.nextElementSibling : null;

      if (!next || !next.classList.contains('js_trust_leiste_item')) {
        next = items[0];
      }

      items.forEach(function (el) {
        el.classList.remove('mobile_active');
      });
      next.classList.add('mobile_active');
    }

    setInterval(selectNext, 5000);
  }
})();
